import { render, staticRenderFns } from "./MainNavBar.vue?vue&type=template&id=b5089f60&scoped=true&"
import script from "./MainNavBar.vue?vue&type=script&lang=js&"
export * from "./MainNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5089f60",
  null
  
)

export default component.exports